import { UserRepository } from "../../repositories/UserRepository";
import { UserEntity } from "../../entities/UserEntity";

/**
 * Create User With Permissions Use Case
 * Creates a new user with role and permissions
 */
export class CreateUserWithPermissionsUseCase {
  constructor(private repository: UserRepository) {}

  async execute(data: {
    email: string;
    userName?: string;
    password: string;
    role_id: number;
    manager_id?: number;
  }): Promise<UserEntity> {
    if (!data.email || !data.email.trim()) {
      throw new Error("Email is required");
    }

    if (!data.password || data.password.length < 6) {
      throw new Error("Password must be at least 6 characters");
    }

    if (!data.role_id || data.role_id <= 0) {
      throw new Error("Role is required");
    }

    return await this.repository.createUserWithPermissions(data);
  }
}
